import { useState, useEffect } from 'react';
import { supabase } from '../config/supabase';

export const useCategories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        console.log('Fetching categories from Supabase...');

        // Fetch categories from the database
        const { data, error: fetchError } = await supabase
          .from('categories')
          .select('*')
          .order('name_en', { ascending: true });

        console.log('Categories response - data:', data, 'error:', fetchError);

        if (fetchError) {
          console.error('Error fetching categories:', fetchError);
          throw fetchError;
        }

        if (data) {
          console.log(`Found ${data.length} categories:`, data);
          setCategories(data);
        } else {
          console.log('No categories found');
          setCategories([]);
        }
      } catch (err) {
        console.error('Error fetching categories:', err);
        setError(err.message);
        setCategories([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  return { categories, loading, error };
};
